import React from 'react';
import PropTypes from 'prop-types';

const ProjectSuccessRenderer = ({ value }) => {
  if (!value || value <= 0) return null;
  return (
    <div className="tw-flex tw-items-center tw-gap-1.5 tw-my-1">
      <div className="tw-flex-1 tw-bg-slate-100 tw-rounded-xl tw-h-1.5">
        <div
          className="tw-bg-primary-500 tw-h-1.5 tw-rounded-xl tw-transition-all"
          style={{ width: `${value}%` }}
        />
      </div>
      <span className="tw-text-[11px] tw-text-slate-500 tw-shrink-0">{value}%</span>
    </div>
  );
};

ProjectSuccessRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ProjectSuccessRenderer;
